<script setup>
import { computed } from 'vue';

import { Skeleton } from 'next/polaris/ui/skeleton';
import { Empty, EmptyDescription } from 'next/polaris/ui/empty';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  empty: {
    type: Boolean,
    default: false,
  },
  query: {
    type: String,
    default: '',
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
  isFetching: {
    type: Boolean,
    default: true,
  },
});

const titleCase = computed(() => props.title.toLowerCase());
</script>

<template>
  <section class="mx-0 mb-3">
    <div
      v-if="showTitle"
      class="sticky top-0 z-20 -mx-1.5 mb-2 bg-gradient-to-b from-polaris-card from-80% to-transparent px-1.5 py-3"
    >
      <h3 class="m-0 type-polaris-label text-polaris-foreground">
        {{ title }}
      </h3>
    </div>
    <slot />
    <div
      v-if="isFetching"
      role="status"
      class="flex flex-col gap-1"
      :aria-label="
        empty ? $t('SEARCH.SEARCHING_DATA') : $t('SEARCH.LOADING_DATA')
      "
    >
      <div
        v-for="row in 3"
        :key="row"
        class="flex items-center gap-3 rounded-polaris-md px-3 py-3"
      >
        <Skeleton class="size-8 flex-shrink-0 rounded-full" />
        <div class="flex min-w-0 flex-1 flex-col gap-2">
          <Skeleton class="h-3.5 w-2/5" />
          <Skeleton class="h-3 w-4/5" />
        </div>
      </div>
    </div>
    <Empty
      v-if="empty && !isFetching"
      class="flex-none border border-solid border-polaris-border p-6 md:p-6"
    >
      <EmptyDescription class="[overflow-wrap:anywhere]">
        {{ $t('SEARCH.EMPTY_STATE', { item: titleCase, query }) }}
      </EmptyDescription>
    </Empty>
  </section>
</template>
